import { useState } from "react";
import type { Episode } from "@/utils/movies";

interface EpisodeListProps {
  episodes: Episode[];
}

export default function EpisodeList({ episodes }: EpisodeListProps) {
  const [active, setActive] = useState<number | null>(episodes.length > 0 ? episodes[0].ep : null);

  if (episodes.length === 0) {
    return (
      <div className="text-sm text-foreground-500 bg-background-100 border border-background-200/60 rounded-lg p-6">
        该作品暂无分集信息。
      </div>
    );
  }

  return (
    <div className="border border-background-200/60 rounded-lg overflow-hidden divide-y divide-background-200/60">
      {episodes.map((episode) => {
        const open = active === episode.ep;
        return (
          <div key={episode.ep} className="bg-background-100">
            <button
              type="button"
              onClick={() => setActive(open ? null : episode.ep)}
              className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left hover:bg-background-200/40 transition-colors cursor-pointer"
            >
              <span className="flex items-center gap-3 min-w-0">
                <span
                  className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-md text-xs font-semibold ${
                    open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-300"
                  }`}
                >
                  {episode.ep}
                </span>
                <span className="min-w-0">
                  <span className="block text-sm md:text-base text-foreground-100 truncate">
                    {episode.title}
                  </span>
                  <span className="block text-xs text-foreground-500 mt-0.5">{episode.duration}</span>
                </span>
              </span>
              <i
                className={`shrink-0 text-foreground-400 transition-transform ${
                  open ? "ri-subtract-line" : "ri-add-line"
                }`}
              />
            </button>
            {open && (
              <div className="px-4 md:px-5 pb-4 pl-14 md:pl-16 hn-fade">
                <p className="text-sm text-foreground-400 leading-relaxed">{episode.synopsis}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}